import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import VerifySMSPage from './VerifySMSPage';

const VerifyRoute: FuseRouteItemType = {
  path: 'verify',
  element: <VerifySMSPage />,
  auth: AUTH_ROLES.onlyGuest,
};

export default VerifyRoute;
